import { createTranslator, type useTranslations } from "next-intl"
import english from "@/translations/en/ui-components.json"

const englishTranslator = createTranslator({locale: "en", messages: english, namespace: "UiComponents.Analytics"})
export type AnalyticsTranslator = ReturnType<typeof useTranslations<"UiComponents.Analytics">>

/** Human-readable durations preserve the dashboard's rounding thresholds. */
export function formatDuration(ms: number | null | undefined, fallback: string, t: AnalyticsTranslator = englishTranslator, locale = "en"): string {
  if (ms === null || ms === undefined) return fallback
  if (ms < 1_000) return t("lessThanSecond")
  if (ms < 59_500) return t("seconds", {count: Math.round(ms / 1_000)})
  const hours = ms / 3_600_000
  if (hours < 1) return t("minutes", {count: Math.round(ms / 60_000)})
  const number = new Intl.NumberFormat(locale, {minimumFractionDigits: 1, maximumFractionDigits: 1})
  if (hours < 48) return t("hours", {count: number.format(hours)})
  return t("days", {count: number.format(hours / 24)})
}

/** A 0–1 share as a whole percentage, or `empty` when there is no population to share. */
export function formatShare(value: number | null, empty: string): string {
  return value === null ? empty : `${wholePercent(value)}%`
}

/** The rounding every displayed share uses, so a change agrees with the shares it compares. */
export function wholePercent(share: number): number {
  return Math.round(share * 100)
}
